import { render, staticRenderFns } from "./BtnPaypal.vue?vue&type=template&id=16e63d76&scoped=true&lang=pug&"
import script from "./BtnPaypal.vue?vue&type=script&lang=js&"
export * from "./BtnPaypal.vue?vue&type=script&lang=js&"
import style0 from "./BtnPaypal.vue?vue&type=style&index=0&id=16e63d76&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e63d76",
  null
  
)

export default component.exports